export default "/images/manufacturer-icon.svg?52de469b24b505c8425a530103c8a1f4";